export default __webpack_public_path__ + "./images/af.38d40f42.png";